"use client";
import React, { useEffect, useState } from "react";
import winnerlogo from "@/assets/winnerlogo-removebg-preview.png";
import Image from "next/image";
import copper from "@/assets/copper-4.jpg";
interface Rank {
  schoolName?: string;
  firstName?: string;
  lastName?: string;
}

interface Winner {
  first?: Rank;
  second?: Rank;
  third?: Rank;
  fourth?: Rank;
}
// type Winner = {
//         first: {
//             firstName: string;
//             lastName: string;
//             schoolName: string;
//         };
//         second: {
//             firstName: string;
//             lastName: string;
//             schoolName: string;
//         };
//         third: {
//             firstName: string;
//             lastName: string;
//             schoolName: string;
//         };

//     };
const mockData = {
  first: {
    firstName: "aditya",
    lastName: "sharma",
    schoolName: "A K JOSHI ENGLISH MEDIUM SCHOOL - THANE",
  },
  second: {
    firstName: "raj",
    lastName: "malhotra",
    schoolName: "A. M. NAIK SCHOOL - POWAI",
  },
  third: {
    firstName: "krish",
    lastName: "",
    schoolName: "A K JOSHI ENGLISH MEDIUM SCHOOL - THANE",
  },
  fourth: {
    firstName: "jiva",
    lastName: "",
    schoolName: "A K JOSHI ENGLISH MEDIUM SCHOOL - THANE",
  },
};

const Winners = ({ winner }: { winner: Winner | null }) => {
  const [winners, setWinners] = useState<Winner | null>(winner);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (winner && (winner.first || winner.second || winner.third)) {
      setWinners(winner);
    } else {
      setWinners(null);
      setError("Winners not declared yet");
    }
  }, [winner]);

  if (loading) return <div>Loading...</div>;
  if (error) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          height: "100px",
        }}
      >
        <div>Winners not declared yet</div>
      </div>
    );
  }
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        gap: "10px",
        flexWrap: "wrap",
        alignItems: "flex-start", // Changed to flex-start to ensure items stay aligned at the top
        height: "auto",
        backgroundColor: "white",
        // flexWrap: 'nowrap',
        width: "100%",
        maxWidth: "1300px",
        margin: "0 auto",
        borderRadius: "20px",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        padding: "20px",
        position: "relative",
        overflow: "hidden",
        overflowX: "auto",
      }}
    >
      {winners?.first ? (
        <div
          style={{
            width: "220px",
            height: "220px",
            border: "1px solid #ccc",
            borderRadius: "10px",
            flex: "1 1 22%",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
            padding: "20px",
            textAlign: "center",
            background:
              "linear-gradient(to bottom, rgba(255, 215, 0, 0.1), rgba(255, 215, 0, 0.5))",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "transparent",
              marginBottom: "10px",
            }}
          >
            <Image src="/gold.svg" alt="gold" width={64} height={64} />
          </div>
          <div
            style={{
              fontWeight: "bold",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {winners.first.firstName && winners.first.lastName
              ? `${winners.first.firstName} ${winners.first.lastName}`
              : ""}
          </div>
          <div
            style={{ fontSize: "0.85rem", color: "gray", textAlign: "center" }}
          >
            {winners?.first?.schoolName || "N/A"}
          </div>
        </div>
      ) : (
        <div
          style={{
            width: "220px",
            height: "220px",
            border: "1px solid #ccc",
            borderRadius: "10px",
            flex: "1 1 22%",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
            padding: "20px",
            textAlign: "center",
            background:
              "linear-gradient(to bottom, rgba(255, 215, 0, 0.1), rgba(255, 215, 0, 0.5))",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          No First Place Winner
        </div>
      )}

      {winners?.second ? (
        <div
          style={{
            width: "220px",
            height: "220px",
            border: "1px solid #ccc",
            borderRadius: "10px",
            flex: "1 1 22%",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
            padding: "20px",
            textAlign: "center",
            background:
              "linear-gradient(to bottom, rgba(192, 192, 192, 0.1), rgba(192, 192, 192, 0.5))",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "transparent",
              marginBottom: "10px",
            }}
          >
            <Image src="/silver.svg" alt="silver" width={64} height={64} />
          </div>
          <div
            style={{
              fontWeight: "bold",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {winners.second.firstName && winners.second.lastName
              ? `${winners.second.firstName} ${winners.second.lastName}`
              : ""}
          </div>

          <div
            style={{ fontSize: "0.85rem", color: "gray", textAlign: "center" }}
          >
            {winners.second.schoolName || "N/A"}
          </div>
        </div>
      ) : (
        <div
          style={{
            width: "220px",
            height: "220px",
            border: "1px solid #ccc",
            borderRadius: "10px",
            flex: "1 1 22%",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
            padding: "20px",
            textAlign: "center",
            background:
              "linear-gradient(to bottom, rgba(192, 192, 192, 0.1), rgba(192, 192, 192, 0.5))",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          No Second Place Winner
        </div>
      )}

      {winners?.third ? (
        <div
          style={{
            width: "220px",
            height: "220px",
            border: "1px solid #ccc",
            borderRadius: "10px",
            flex: "1 1 22%",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
            padding: "20px",
            textAlign: "center",
            background:
              "linear-gradient(to bottom, rgba(205, 127, 50, 0.1), rgba(205, 127, 50, 0.5))",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "transparent",
              marginBottom: "10px",
            }}
          >
            <Image src="/bronze.svg" alt="bronze" width={64} height={64} />
          </div>
          <div
            style={{
              fontWeight: "bold",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {winners.third.firstName && winners.third.lastName
              ? `${winners.third.firstName} ${winners.third.lastName}`
              : ""}
          </div>
          <div
            style={{ fontSize: "0.85rem", color: "gray", textAlign: "center" }}
          >
            {winners.third.schoolName || "N/A"}
          </div>
        </div>
      ) : (
        <div
          style={{
            width: "220px",
            height: "220px",
            border: "1px solid #ccc",
            borderRadius: "10px",
            flex: "1 1 22%",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
            padding: "20px",
            textAlign: "center",
            background:
              "linear-gradient(to bottom, rgba(205, 127, 50, 0.1), rgba(205, 127, 50, 0.5))",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          No Third Place Winner
        </div>
      )}

      {winners?.fourth ? (
        <div
          style={{
            width: "220px",
            height: "220px",
            border: "1px solid #ccc",
            borderRadius: "10px",
            flex: "1 1 22%",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
            padding: "20px",
            textAlign: "center",
            background:
              "linear-gradient(to bottom, rgba(205, 127, 50, 0.1), rgba(205, 127, 50, 0.5))",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "transparent",
              marginBottom: "10px",
            }}
          >
            <Image
              src={copper}
              alt="copper"
              style={{ width: "60px", height: "60px" }}
            />
          </div>
          <div
            style={{
              fontWeight: "bold",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {winners.fourth.firstName && winners.fourth.lastName
              ? `${winners.fourth.firstName} ${winners.fourth.lastName}`
              : ""}
          </div>
          <div
            style={{ fontSize: "0.85rem", color: "gray", textAlign: "center" }}
          >
            {winners.fourth.schoolName || "N/A"}
          </div>
        </div>
      ) : (
        <div></div>
      )}

      {/* The Winner Logo */}
      <div
        style={{
          position: "absolute",
          bottom: "20px",
          right: "0",
          display: "flex",
          justifyContent: "right",
          alignItems: "center",
          width: "150px",
        }}
      >
        <Image
          src={winnerlogo}
          alt="Winner Logo"
          style={{
            width: "150px",
            height: "auto",
            transform: "translateY(-110px)",
          }}
        />
      </div>
    </div>
  );
};

export default Winners;
